import { BaseRequests } from "../../../config/BaseRequests";
import { dashboardApiEndpoints } from "../api/dashboard.api";
import { DashboardStatsDto } from "../dto/dashboard.dto";

export class DashboardService {
  static getStats = (): Promise<DashboardStatsDto> =>
    BaseRequests.get(dashboardApiEndpoints.getStats);
}
